// LootjesAanmaken.jsx — /lootjes
// Organisator maakt een lootjesgroep aan

import { useState } from "react";
import { BUDGETS, INTERESTS } from "../constants";
import { Events } from "../analytics";

export default function LootjesAanmaken() {
  const [stap, setStap] = useState(1); // 1=info, 2=jouw profiel, 3=klaar
  const [naam, setNaam] = useState("");
  const [budget, setBudget] = useState(null);
  const [datum, setDatum] = useState("");
  const [orgNaam, setOrgNaam] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgInteresses, setOrgInteresses] = useState([]);
  const [laden, setLaden] = useState(false);
  const [resultaat, setResultaat] = useState(null);
  const [gekopieerd, setGekopieerd] = useState(false);

  const ok1 = naam.trim() && budget;
  const ok2 = orgNaam.trim() && orgEmail.includes("@") && orgInteresses.length === 2;

  async function maakGroep() {
    if (!ok2 || laden) return;
    setLaden(true);
    try {
      const res = await fetch("/.netlify/functions/lootjes", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          naam: naam.trim(),
          budget,
          datum: datum || null,
          organisatorNaam: orgNaam.trim(),
          organisatorEmail: orgEmail,
          organisatorInteresses: orgInteresses,
        }),
      });
      const json = await res.json();
      setResultaat(json);
      setStap(3);
      Events.track("Lootjes groep aangemaakt", { budget });
    } catch {
      alert("Er ging iets mis. Probeer opnieuw.");
    } finally {
      setLaden(false);
    }
  }

  const kopieer = (tekst) => {
    navigator.clipboard.writeText(tekst).then(() => {
      setGekopieerd(true);
      setTimeout(() => setGekopieerd(false), 2500);
    });
  };

  // ── Stap 1: groepsinfo ─────────────────────────────────────────
  if (stap === 1) return (
    <main className="main">
      <div className="card fi">
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🎁</div>
          <h1 className="step" style={{ marginBottom: 6 }}>Lootjes trekken<br/>met <em>Givn</em></h1>
          <p className="sub">Iedereen krijgt direct cadeausuggesties bij zijn lootje. Geen gedoe, geen generieke lijstjes.</p>
        </div>

        <div className="flabel">Naam van de groep</div>
        <input className="inp" placeholder='bijv. "Kerstdiner vrienden" of "Familie 2026"'
          value={naam} onChange={e => setNaam(e.target.value)} autoFocus />

        <div className="flabel">Budget per persoon</div>
        <div className="bgrid">
          {BUDGETS.map(b => (
            <div key={b.id} className={"bcard " + (budget === b.id ? "sel" : "")}
              onClick={() => setBudget(b.id)}>
              <div className="bl">{b.l}</div>
              <div className="bs">{b.s}</div>
            </div>
          ))}
        </div>

        <div className="flabel" style={{ marginTop: 4 }}>
          Datum <span style={{ color: "#8A7B73", fontWeight: 400 }}>(optioneel)</span>
        </div>
        <input className="inp inp-rect" type="date" value={datum}
          min={new Date().toISOString().split("T")[0]}
          onChange={e => setDatum(e.target.value)}
          style={{ marginBottom: 20 }} />

        <button className={"bfull bn " + (ok1 ? "on" : "off")}
          onClick={() => ok1 && setStap(2)}>
          Verder →
        </button>
      </div>
    </main>
  );

  // ── Stap 2: organisator profiel ────────────────────────────────
  if (stap === 2) return (
    <main className="main">
      <div className="card fi">
        <div className="tag">Jouw profiel</div>
        <h1 className="step">Wie ben <em>jij</em>?</h1>
        <p className="sub">Zodat jij ook een goed lootje krijgt als iemand jou trekt.</p>

        <div className="flabel">Jouw naam</div>
        <input className="inp" placeholder="Voornaam" value={orgNaam}
          onChange={e => setOrgNaam(e.target.value)} autoFocus />

        <div className="flabel">Jouw e-mailadres</div>
        <input className="inp" placeholder="jouw@email.nl" type="email"
          value={orgEmail} onChange={e => setOrgEmail(e.target.value)} />
        <p className="sub" style={{ fontSize: 12, marginTop: -10, marginBottom: 16 }}>
          Voor het versturen van jouw lootje en herinneringen.
        </p>

        <div className="flabel">
          Jouw interesses <span style={{ color: "#8A7B73", fontWeight: 400 }}>(kies er 2)</span>
          {orgInteresses.length === 2 && <span style={{ color: "#3D5A4C", fontWeight: 600 }}> ✓</span>}
        </div>
        <div className="chips">
          {INTERESTS.map(i => {
            const sel = orgInteresses.includes(i.id);
            return (
              <div key={i.id} className={"chip" + (sel ? " sel" : "")}
                onClick={() => {
                  const next = sel
                    ? orgInteresses.filter(x => x !== i.id)
                    : orgInteresses.length < 2 ? [...orgInteresses, i.id] : orgInteresses;
                  setOrgInteresses(next);
                }}>
                <span>{i.e}</span>{i.l}
              </div>
            );
          })}
        </div>

        <div className="brow">
          <button className="bbk" onClick={() => setStap(1)}>← Terug</button>
          <button className={"bn " + (ok2 ? "gr" : "off")}
            onClick={maakGroep} disabled={laden}>
            {laden ? "Aanmaken…" : "Maak groep aan ✓"}
          </button>
        </div>
      </div>
    </main>
  );

  // ── Stap 3: groep aangemaakt ───────────────────────────────────
  return (
    <main className="main">
      <div className="card fi">
        <div style={{
          background: "linear-gradient(135deg,#3D5A4C,#4a6b5a)",
          borderRadius: 20, padding: 24, marginBottom: 22, textAlign: "center",
        }}>
          <div style={{ fontSize: 48, marginBottom: 10 }}>🎉</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "white", marginBottom: 6 }}>
            {naam} is aangemaakt!
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.7 }}>
            Stuur de link naar je groep. Zodra iedereen binnen is trek jij de lootjes.
          </div>
        </div>

        {/* Deellink */}
        <div className="flabel">Stuur deze link naar je groep</div>
        <div style={{
          background: "#FDEEE8", border: "1.5px solid #EDE3D9",
          borderRadius: 14, padding: "12px 14px", marginBottom: 10,
          fontSize: 13, color: "#2C2420", wordBreak: "break-all",
          fontFamily: "monospace",
        }}>
          {resultaat?.deelUrl}
        </div>

        <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
          <a href={"https://api.whatsapp.com/send?text=" + encodeURIComponent(
            `Hey! Ik heb een lootjesgroep aangemaakt via Givn 🎁\n\nDoe je mee? Vul je naam en interesses in, dan trekken we de lootjes en krijg je direct cadeausuggesties:\n\n${resultaat?.deelUrl}`
          )}
            target="_blank" rel="noopener noreferrer"
            style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
              gap: 6, padding: "11px 8px", borderRadius: 12,
              background: "#25D366", color: "white",
              fontWeight: 700, fontSize: 13, textDecoration: "none",
              fontFamily: "'DM Sans',sans-serif",
            }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            WhatsApp
          </a>
          <button onClick={() => kopieer(resultaat?.deelUrl)}
            style={{
              flex: 1, padding: "11px 8px", borderRadius: 12,
              border: "1.5px solid #EDE3D9",
              background: gekopieerd ? "#EDF3EF" : "white",
              color: gekopieerd ? "#3D5A4C" : "#2C2420",
              fontWeight: 700, fontSize: 13, cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}>
            {gekopieerd ? "✓ Gekopieerd" : "📋 Kopieer"}
          </button>
        </div>

        {/* Beheerderslink */}
        <div style={{
          background: "#EDF3EF", border: "1px solid rgba(61,90,76,0.15)",
          borderRadius: 14, padding: "14px 16px",
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#2C2420", marginBottom: 4 }}>
            🔐 Jouw beheerderslink — bewaar deze!
          </div>
          <div style={{ fontSize: 12, color: "#8A7B73", marginBottom: 10, lineHeight: 1.6 }}>
            Via deze link kun jij de lootjes trekken zodra iedereen binnen is.
          </div>
          <button onClick={() => kopieer(resultaat?.beheerdersUrl)}
            style={{
              width: "100%", padding: "10px 0", borderRadius: 50,
              border: "1.5px solid #3D5A4C", background: "white",
              color: "#3D5A4C", fontWeight: 700, fontSize: 13,
              cursor: "pointer", fontFamily: "'DM Sans',sans-serif",
            }}>
            📋 Kopieer beheerderslink
          </button>
        </div>
      </div>
    </main>
  );
}
